<template>
  <div>
    <h2 class="careering shine">Create a Role</h2>
    <p1>Design your role at USB Club.</p1>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      <b>You’ll be joining</b> a versatile team of two.
      <a href="https://twitter.com/thecpe" target="_blank">Yatú</a> keeps us
      moving as the Head of Reality, while
      <a href="https://twitter.com/usbnorm" target="_blank">Norm</a> keeps us
      imagining as the Head of Fiction. We’re based in New York City building a
      worldwide network.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <FadedImage name="in-the-palm-of-your-hand.png" />
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      <b>We're looking for</b> individuals who have either discovered a new role
      they want to apply at USB Club, or are looking to discover a new role with
      us.
    </p3>
    <div class="spacer"></div>
    <p3>
      We encourage quick learning and a playful spirit in our journey to help
      bridge the digital and physical worlds. To learn about how we approach
      learning and working, checkout our theory of
      <a href="https://www.careering.life" target="_blank">Careering</a>.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3
      ><b>Propose a role</b> by sending us a brief description about your role
      and why the role is a good fit for USB Club.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>Role descriptions can include:</p3>
    <ul>
      <li>What is the driving purpose and impact of the role?</li>
      <li>What are the skillsets and tools related to the role?</li>
      <li>Who would be your closest collaborators?</li>
    </ul>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      Email <span class="email">y@usbclub.net</span> with your role description,
      resume, and portfolio to kickstart the application process.
    </p3>
    <div class="spacer"></div>
    <p3
      >We’re committed to creating an encouraging environment for all
      collaborators and teammates, and we look forward to hearing from you.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>

    <Footer :fixed="false" />
  </div>
</template>

<script>
import Footer from "../Footer.vue";
import FadedImage from "../FadedImage.vue";

export default {
  name: "CreateRole",
  components: {
    Footer,
    FadedImage,
  },
  head() {
    return {
      title: "Create a Role",
      meta: [
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:title",
          content: "Create a Role",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:description",
          content: "Career with us.",
        },
        {
          name: "description",
          content: "Career with us.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:description",
          content: "Career with us.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:title",
          content: "Create a Role",
        },
      ],
    };
  },
};
</script>
